"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dxp_ai_client_react_1 = require("@squiz/dxp-ai-client-react");
const sds_1 = require("@squiz/sds");
const react_1 = require("react");
const hooks_1 = require("../../../hooks");
const icons_1 = require("../../../icons");
const ModalFooter = ({ contentTool }) => {
    const { rateThread } = (0, dxp_ai_client_react_1.useAiService)();
    const [flagged, setFlagged] = (0, react_1.useState)(false);
    const { threadId } = (0, hooks_1.useStore)();
    const [isRating, setRating] = (0, react_1.useState)(false);
    const flagForReview = (0, react_1.useCallback)(() => {
        setRating(true);
        rateThread(contentTool, threadId, 'negative').then(() => {
            setFlagged(true);
            setRating(false);
        });
    }, [contentTool, rateThread, setFlagged, threadId]);
    if (!threadId) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Result not as expected?", ' ', flagged && ((0, jsx_runtime_1.jsxs)("span", { className: "dxp-ctm-flagged", children: [icons_1.ICON_FLAG, " Flagged ", sds_1.ICON_CHECK] })), !flagged && ((0, jsx_runtime_1.jsx)(sds_1.Button, { text: "Flag for review", theme: sds_1.BUTTON_THEME_DEFAULT, format: sds_1.BUTTON_FORMAT_TRANSPARENT, icon: icons_1.ICON_FLAG_OUTLINE, onClick: flagForReview, isLoading: isRating, isDisabled: isRating }))] }));
};
exports.ModalFooter = ModalFooter;
